import { Typography, TypographyVariant } from '@mui/material';
import { ReactNode } from 'react';


interface HorizontalLabeledValueProps {
    label: ReactNode;
    value: ReactNode;
    classNames?: {
        label?: string;
        value?: string;
    };
    variant?: TypographyVariant;
    labelVariant?: TypographyVariant;
}

export function HorizontalLabeledValue({
    label, value, classNames, variant, labelVariant
}: HorizontalLabeledValueProps) {
    return (
        <>
            <Typography
                variant={labelVariant || 'caption'}
                color="textSecondary"
                className={classNames?.label}
                textAlign="right"
            >
                {label}&nbsp;
            </Typography>

            <Typography
                variant={variant || 'body2'}
                className={classNames?.value}
            >
                {value}
            </Typography>
        </>
    );
}
